import { create } from 'zustand';

import { PermissionRole } from '@/entities/PermissionRoles';

interface PermissionStore {
	userPermission: PermissionRole;
	teamIds: string[];
	captainTeamIds: string[];
	setPermission: (permission: PermissionRole) => void;
	setTeamIds: (teamId: string[]) => void;
	setCaptainTeamIds: (teamIds: string[]) => void;
	unlimitedAccess: boolean;
	gamedayAccess: boolean;
	canManageTeamLeague: boolean;
	setUnlimitedAccess: (v: boolean) => void;
	setGamedayAccess: (v: boolean) => void;
	setManageTeamLeague: (v: boolean) => void;
}

export const usePermissionStore = create<PermissionStore>((set) => ({
	userPermission: PermissionRole.NOT_AUTHORIZED,
	setPermission: (permission: PermissionRole) => set(() => ({ userPermission: permission })),
	teamIds: [],
	setTeamIds: (ids: string[]) => set(() => ({ teamIds: ids })),
	captainTeamIds: [],
	setCaptainTeamIds: (ids: string[]) => set(() => ({ captainTeamIds: ids })),
	unlimitedAccess: false,
	gamedayAccess: false,
	canManageTeamLeague: false,
	setUnlimitedAccess: (v: boolean) => set(() => ({ unlimitedAccess: v })),
	setGamedayAccess: (v: boolean) => set(() => ({ gamedayAccess: v })),
	setManageTeamLeague: (v: boolean) => set(() => ({ canManageTeamLeague: v }))
}));
